if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // The button stays locked while the page heads to the cart (see below);
        // a page restored by Back gets it unlocked again.
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted || !this.redirectingToCart) return;
          this.redirectingToCart = false;
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const quickAddModal = this.closest('quick-add-modal');
        const formSource = quickAddModal ? 'quick_add' : 'product-form';
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        let cartAddResponseReceived = false;
        let cartErrorReported = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            cartAddResponseReceived = true;

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: formSource,
                productVariantId: formData.get('id'),
                quantity: formData.get('quantity'),
                status: response.status,
                errors: response.errors || response.description,
                message: response.message,
              });
              cartErrorReported = true;
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            document.dispatchEvent(new CustomEvent('cts:cart-added', {
              detail: {
                product_id: response.product_id,
                variant_id: response.variant_id || formData.get('id'),
                quantity: Number(formData.get('quantity') || 1),
                form_source: formSource,
                product_title: response.product_title,
                // Discounted unit price in Shopify's 1/100 units: final_price is
                // net of line discounts, price is not. Listeners convert it; the
                // product page context is wrong here for quick add, where the
                // added product is not the page's.
                price_cents: Number.isFinite(response.final_price) ? response.final_price : response.price,
              },
            }));

            if (!this.cart) {
              // Keep the button locked until the cart page loads, so a second
              // tap in the meantime can't add the item again.
              this.redirectingToCart = true;
              setTimeout(() => {
                window.location = window.routes.cart_url;
              }, 500);
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            if (!cartErrorReported && !cartAddResponseReceived) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: formSource,
                productVariantId: formData.get('id'),
                quantity: formData.get('quantity'),
                errors: e?.message,
                message: 'Cart add request failed',
              });
            }
            console.error(e);
          })
          .finally(() => {
            if (this.redirectingToCart) return;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
